import { AnyRoute, createRoute } from '@tanstack/react-router'
import { routes } from 'commons/constants/routes'

import TemplateManageWrapper from './TemplateManageWrapper'
import { templateDetailsRoute, templateEditRoute, templatesListRoute } from './routes'

export const bankDocumentTemplatesRoute = <T extends AnyRoute>(rootRoute: T) => {
  const documentTemplatesIndexRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: routes.bank.documentTemplates.index,
    component: TemplateManageWrapper
  })

  return documentTemplatesIndexRoute.addChildren([
    templatesListRoute<typeof documentTemplatesIndexRoute>(documentTemplatesIndexRoute),
    templateEditRoute<typeof documentTemplatesIndexRoute>(documentTemplatesIndexRoute),
    templateDetailsRoute<typeof documentTemplatesIndexRoute>(documentTemplatesIndexRoute)
  ])
}
